import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance } from './URLProtocol.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  indexOfAny2ijjuuzpljsyd as indexOfAny,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  substring3saq8ornu0luv as substring,
  substringiqarkczpya5m as substring_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  get_hostWithPortIfSpecified1w0e2oq2yfcan as get_hostWithPortIfSpecified,
  Urlowwyg1lanrqp as Url,
  appendUserAndPassword2m6va0hoftk5 as appendUserAndPassword,
} from './URLUtils.mjs';
import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function Url$_get_encodedPath_$ref_fg9j48() {
  return constructCallableReference((p0) => p0.get_encodedPath_p9zwnq_k$(), 1, 0, 209);
}
function Url$_get_encodedQuery_$ref_c7vq1h() {
  return constructCallableReference((p0) => p0.get_encodedQuery_28s95p_k$(), 1, 0, 210);
}
function Url$_get_encodedUser_$ref_3lb9bi() {
  return constructCallableReference((p0) => p0.get_encodedUser_p9wcq8_k$(), 1, 0, 211);
}
function Url$_get_encodedPassword_$ref_25ixc2() {
  return constructCallableReference((p0) => p0.get_encodedPassword_rswp28_k$(), 1, 0, 212);
}
function Url$_get_encodedFragment_$ref_itp7pv() {
  return constructCallableReference((p0) => p0.get_encodedFragment_jm6jcb_k$(), 1, 0, 213);
}
var UrlClass;
function Url_0() {
  if (UrlClass === VOID) {
    class $ {
      constructor(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
        this.host_1 = host;
        this.specifiedPort_1 = specifiedPort;
        this.parameters_1 = parameters;
        this.fragment_1 = fragment;
        this.user_1 = user;
        this.password_1 = password;
        this.trailingQuery_1 = trailingQuery;
        this.urlString_1 = urlString;
        var containsArg = this.specifiedPort_1;
        // Inline function 'kotlin.require' call
        if (!(0 <= containsArg ? containsArg <= 65535 : false)) {
          var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + this.specifiedPort_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        this.pathSegments_1 = pathSegments;
        this.rawSegments_1 = pathSegments;
        var tmp = this;
        tmp.segments$delegate_1 = lazy(() => {
          var tmp;
          if (pathSegments.isEmpty_y1axqb_k$()) {
            return emptyList();
          }
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = first(pathSegments);
          if (charSequenceLength(this_0) === 0) {
            tmp_1 = pathSegments.get_size_woubt6_k$() > 1;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = 1;
          } else {
            tmp_0 = 0;
          }
          var start = tmp_0;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = last(pathSegments);
          if (charSequenceLength(this_1) === 0) {
            tmp_2 = get_lastIndex(pathSegments);
          } else {
            tmp_2 = get_lastIndex(pathSegments) + 1 | 0;
          }
          var end = tmp_2;
          return pathSegments.subList_xle3r2_k$(start, end);
        });
        this.protocolOrNull_1 = protocol;
        var tmp_0 = this;
        var tmp0_elvis_lhs = this.protocolOrNull_1;
        tmp_0.protocol_1 = tmp0_elvis_lhs == null ? Companion_getInstance().HTTP_1 : tmp0_elvis_lhs;
        var tmp_1 = this;
        tmp_1.encodedPath$delegate_1 = lazy(() => {
          var tmp;
          if (pathSegments.isEmpty_y1axqb_k$()) {
            return '';
          }
          var pathStartIndex = indexOf(this.urlString_1, _Char___init__impl__6a9atx(47), this.protocol_1.name_1.length + 3 | 0);
          var tmp_0;
          if (pathStartIndex === -1) {
            return '';
          }
          // Inline function 'kotlin.charArrayOf' call
          var tmp$ret$4 = charArrayOf([_Char___init__impl__6a9atx(63), _Char___init__impl__6a9atx(35)]);
          var pathEndIndex = indexOfAny(this.urlString_1, tmp$ret$4, pathStartIndex);
          var tmp_1;
          if (pathEndIndex === -1) {
            return substring(this.urlString_1, pathStartIndex);
          }
          return substring_0(this.urlString_1, pathStartIndex, pathEndIndex);
        });
        var tmp_2 = this;
        tmp_2.encodedQuery$delegate_1 = lazy(() => {
          var queryStart = indexOf(this.urlString_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
          var tmp;
          if (queryStart === 0) {
            return '';
          }
          var queryEnd = indexOf(this.urlString_1, _Char___init__impl__6a9atx(35), queryStart);
          var tmp_0;
          if (queryEnd === -1) {
            return substring(this.urlString_1, queryStart);
          }
          return substring_0(this.urlString_1, queryStart, queryEnd);
        });
        var tmp_3 = this;
        tmp_3.encodedPathAndQuery$delegate_1 = lazy(() => {
          var pathStart = indexOf(this.urlString_1, _Char___init__impl__6a9atx(47), this.protocol_1.name_1.length + 3 | 0);
          var tmp;
          if (pathStart === -1) {
            return '';
          }
          var queryEnd = indexOf(this.urlString_1, _Char___init__impl__6a9atx(35), pathStart);
          var tmp_0;
          if (queryEnd === -1) {
            return substring(this.urlString_1, pathStart);
          }
          return substring_0(this.urlString_1, pathStart, queryEnd);
        });
        var tmp_4 = this;
        tmp_4.encodedUser$delegate_1 = lazy(() => {
          var tmp;
          if (this.user_1 == null) {
            return null;
          }
          var tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = this.user_1;
          if (charSequenceLength(this_0) === 0) {
            return '';
          }
          var usernameStart = this.protocol_1.name_1.length + 3 | 0;
          // Inline function 'kotlin.charArrayOf' call
          var tmp$ret$6 = charArrayOf([_Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(64)]);
          var usernameEnd = indexOfAny(this.urlString_1, tmp$ret$6, usernameStart);
          return substring_0(this.urlString_1, usernameStart, usernameEnd);
        });
        var tmp_5 = this;
        tmp_5.encodedPassword$delegate_1 = lazy(() => {
          var tmp;
          if (this.password_1 == null) {
            return null;
          }
          var tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = this.password_1;
          if (charSequenceLength(this_0) === 0) {
            return '';
          }
          var passwordStart = indexOf(this.urlString_1, _Char___init__impl__6a9atx(58), this.protocol_1.name_1.length + 3 | 0) + 1 | 0;
          var passwordEnd = indexOf(this.urlString_1, _Char___init__impl__6a9atx(64));
          return substring_0(this.urlString_1, passwordStart, passwordEnd);
        });
        var tmp_6 = this;
        tmp_6.encodedFragment$delegate_1 = lazy(() => {
          var fragmentStart = indexOf(this.urlString_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
          var tmp;
          if (fragmentStart === 0) {
            return '';
          }
          return substring(this.urlString_1, fragmentStart);
        });
      }
      get_port_wosj4a_k$() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.specifiedPort_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? this.protocol_1.defaultPort_1 : tmp0_elvis_lhs;
      }
      get_encodedPath_p9zwnq_k$() {
        var tmp0 = this.encodedPath$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedPath', 1, tmp, Url$_get_encodedPath_$ref_fg9j48(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_encodedQuery_28s95p_k$() {
        var tmp0 = this.encodedQuery$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedQuery', 1, tmp, Url$_get_encodedQuery_$ref_c7vq1h(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_encodedUser_p9wcq8_k$() {
        var tmp0 = this.encodedUser$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedUser', 1, tmp, Url$_get_encodedUser_$ref_3lb9bi(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_encodedPassword_rswp28_k$() {
        var tmp0 = this.encodedPassword$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedPassword', 1, tmp, Url$_get_encodedPassword_$ref_25ixc2(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_encodedFragment_jm6jcb_k$() {
        var tmp0 = this.encodedFragment$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedFragment', 1, tmp, Url$_get_encodedFragment_$ref_itp7pv(), null);
        return tmp0.get_value_j01efc_k$();
      }
      toString() {
        return this.urlString_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof Url_0()))
          THROW_CCE();
        return this.urlString_1 === other.urlString_1;
      }
      hashCode() {
        return getStringHashCode(this.urlString_1);
      }
    }
    initMetadataForClass($, 'Url', VOID, VOID, VOID, VOID, VOID, {0: UrlSerializer_getInstance});
    UrlClass = $;
  }
  return UrlClass;
}
function get_authority(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  this_0.append_22ad7x_k$(get_encodedUserAndPassword(_this__u8e3s4));
  this_0.append_22ad7x_k$(get_hostWithPortIfSpecified(_this__u8e3s4));
  return this_0.toString();
}
var UrlSerializerClass;
function UrlSerializer() {
  if (UrlSerializerClass === VOID) {
    class $ {
      constructor() {
        UrlSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('io.ktor.http.Url', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Url(decoder.decodeString_x3hxsx_k$());
      }
      serialize_30km78_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_30km78_k$(encoder, value instanceof Url_0() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'UrlSerializer', VOID, VOID, [KSerializer()]);
    UrlSerializerClass = $;
  }
  return UrlSerializerClass;
}
var UrlSerializer_instance;
function UrlSerializer_getInstance() {
  if (UrlSerializer_instance === VOID)
    new (UrlSerializer())();
  return UrlSerializer_instance;
}
function get_encodedUserAndPassword(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  appendUserAndPassword(this_0, _this__u8e3s4.get_encodedUser_p9wcq8_k$(), _this__u8e3s4.get_encodedPassword_rswp28_k$());
  return this_0.toString();
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Url_0 as Url1652zsz51o0h6,
  get_authority as get_authority2s3hk87lssumy,
};
//endregion

//# sourceMappingURL=Url.mjs.map
